import {ReadCampaign} from '@tinct/core-api-models';
import {useUnpublishCampaignLandingPage} from '@tinct/core-api';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tinct/web-components';
import {toast} from 'sonner';

type UnpublishLandingPageModalProps = {
  campaign: ReadCampaign;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/**
 * NEW-origin counterpart of UnpublishCampaignModal: taking the hosted page
 * down is synchronous — no unpublish job to poll.
 */
export const UnpublishLandingPageModal = ({
  campaign,
  open,
  onOpenChange,
}: UnpublishLandingPageModalProps) => {
  const {mutate: unpublishLandingPage, isPending} = useUnpublishCampaignLandingPage({
    onSuccess: () => {
      toast.success('Landing page unpublished');
      onOpenChange(false);
    },
    onError: () => {
      toast.error('Could not unpublish the page. Please try again.');
    },
  });

  const handleConfirm = () => {
    if (!campaign.id) return;
    unpublishLandingPage({id: campaign.id});
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] rounded-3xl p-8">
        <DialogHeader>
          <DialogTitle>Unpublish page</DialogTitle>
          <DialogDescription>
            <span className="font-semibold">{campaign.name ?? '—'}</span>
            {"'s landing page will be taken down and no longer reachable by your audience."}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-between">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleConfirm} disabled={isPending}>
            {isPending ? 'Unpublishing...' : 'Unpublish'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
